import styled from 'styled-components'

export const Tr = ({extra, type, onClick, ...props}) => {
  return (
    <StyledTr {...props} data-type={type}>
      <div className="tr__container" onClick={onClick}>
        {props?.children}
      </div>
      {extra && <div className="tr__extra">{extra}</div>}
    </StyledTr>
  )
}

const StyledTr = styled.div`
  border-top: 1px solid #e2eaf8;
  border-bottom: 1px solid transparent;
  //background: #ffffff;
  &[data-type='tHead'] {
    background: rgb(239, 243, 251) !important;
    .tr {
      &__container {
        background: #eff3fb !important;
      }
    }
  }

  &[data-active='true'] {
    .tr {
      &__container {
        background: #e2eaf8 !important;
      }
    }
  }
  &:hover {
    border-bottom: 1px solid #f3f6fc;
    .tr {
      &__container {
        background: #f3f6fc;
      }
    }
  }

  &:last-child{
    border-bottom: 1px solid #e2eaf8;
  }
  .tr {
    &__container {
      width: 100%;
      display: flex;
      align-items: center;

      background: #fff;

      transition: background 0.25s;
    }
  }
`
